<template>
    <div>
        <v-layout row wrap align-space-around justify-center fill-height class="mt-5">
            <v-divider class="red divider-custom-height mt-5 ml-3 mr-3"></v-divider>
            <v-card-text class="py-5">
                <h1 class="text-lg-center text-md-center text-xs-center display-3 font-weight-black primary--text" >
                    {{ $t("program.program-text") }}
                </h1>
            </v-card-text>
            <v-layout row justify-center align-stretch class="mb-5">
                <v-flex xs12 md4 lg3 class="pt-5 mr-3">
                <v-card-text class="">
                     <v-card flat class="background">
                        <div class="text-lg-center text-md-center text-xs-center">
                            <img :src="require(`@/assets/screen-${darkMode ? 'white' : 'black'}.png`)" aspect-ratio="">
                        </div>
                        <v-card-title primary-title>
                            <div>
                                <div class="card-title">
                                    <a href="#">{{ program.film_play_section_current_language.title }}</a>
                                </div>
                                <div class="mt-4 secondary--text" v-html="program.film_play_section_current_language.description"></div>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-card-text>
                </v-flex>
                <v-flex xs12 md4 lg3 class="pt-5 ml-3">
                    <v-card-text height="100%">
                        <v-card flat class="background ">
                            <div class="text-lg-center text-md-center text-xs-center">
                                <img :src="require(`@/assets/q-and-a-${darkMode ? 'white' : 'black'}.png`)" aspect-ratio="">
                            </div>
                            <v-card-title primary-title class="background--text">
                                <div>
                                    <div class="card-title">
                                        <a href="#">{{ program.question_answer_section_current_language.title }}</a>
                                    </div>
                                    <div class="mt-4 secondary--text" v-html="program.question_answer_section_current_language.description"></div>
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-card-text>
                </v-flex>
            </v-layout>
        </v-layout>
        <v-divider class="red divider-custom-height mt-5 ml-3 mr-3 mb-5"></v-divider>
        <v-layout class="mt-2" row wrap>
            <v-flex xs12>
                <ProgramSection 
                    :program="program" 
                    :programPayload.sync="programPayload" 
                    @filterActiveProgram="getActiveProgram" 
                />
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ProgramSection from '@/components/company/program/ProgramSection';
export default {
    name: "Program",
    components: {
        ProgramSection
    },
    data() {
        return {
            program: null,
            programPayload: {
                company_id: null,
                status: 1,
                sort: "created_at",
                sorting_order: true,
                filters: {
                    search:"",
                    year: "",
                    film_sections: "",
                    film_types: "",
                    country: "",
                    screenerDate: "",
                },
            },
        }
    },
    computed: {
        ...mapGetters("app", {
            darkMode: "darkMode",
            currentLanguage: "getCurrentLanguage"
        }),
        ...mapState({
            currentCompany: (state) => state.company.company,
        }),
    },
    mounted() {
        this.getActiveProgram();
    },
    watch: {
        currentLanguage: {
            handler(){
                this.getActiveProgram()
            }
        }
    },
    methods:{
        async getActiveProgram() {
            try {
                this.programPayload.company_id = this.currentCompany.id;
                var response = await this.$store.dispatch(
                    "program/get",
                    this.programPayload
                );
                this.program = response.program;
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error",
                });
            }
        },
    }

}
</script>
